import React from "react";

import { Container, Img, LabelButton } from "./Styles";

const ChangeIcon = ({src, onChange}) => {
    const id = "txtChangeLogo"

    return(
        <Container>
            <LabelButton htmlFor={id}>Cambiar</LabelButton>
            <Img src={src} alt="icon" />
            <input onChange={onChange} id={id} type="file" style={{ display: 'none' }} accept=".jpef,.jpg,.png"/>
        </Container>
    )
}

export default ChangeIcon;